module.exports = __webpack_public_path__ + "static/media/buble_chat.6b19fceb.svg";